module.exports = __webpack_public_path__ + "static/media/gallery13.aced9044.jpg";